import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { TimeRange} from "@@/shared/date-time/time-range";
import { timeRangeZodSchema } from "@@/shared/date-time/time-range";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ResourceId} from "../../resources/resource-id";
import { resourceIdZodSchema } from "../../resources/resource-id";

type DropInResourceCommand = {
    _id: string;
    _createdAt: IsoAndUnixTimestamp;
    _type: "DROP_IN_COMMAND";
    providerId: ProviderId;
    timeRange: TimeRange;
    resourceId: ResourceId;
};

type FactoryParams = Except<
    DropInResourceCommand,
    "_id" | "_type" | "_createdAt"
>;
const dropInResourceFactory = (params: FactoryParams) => {
    const command: DropInResourceCommand = {
        ...params,
        _id: generateId({ prefix: "drop_in__" }),
        _type: "DROP_IN_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};
const { zodSchema: blockResourceIdZodSchema } = genericId("drop_in__");

const DropInResourceCommandSchema: z.ZodSchema<DropInResourceCommand> =
    z.object({
        _id: blockResourceIdZodSchema,
        _type: z.literal("DROP_IN_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        resourceId: resourceIdZodSchema,
        timeRange: timeRangeZodSchema,
    });

export { DropInResourceCommandSchema, dropInResourceFactory };
export type { DropInResourceCommand };
